import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import SelectAsync from 'react-select/async';
export default class Personnel extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/personnel/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/personnel/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            firstName: this.state.data.record.firstName,
            lastName: this.state.data.record.lastName,
            fatherName: this.state.data.record.fatherName,
            nationalCode: this.state.data.record.nationalCode,
            numberId: this.state.data.record.numberId,
            placeOfIssue: this.state.data.record.placeOfIssue,
            birthDay: this.state.data.record.birthDay,
            maritalStatus: this.state.data.record.maritalStatus,
            numberOfChildren: this.state.data.record.numberOfChildren,
            insuranceNumber: this.state.data.record.insuranceNumber,
            lastCertificate: this.state.data.record.lastCertificate,
            fieldStudy: this.state.data.record.fieldStudy,
            serviceStatus: this.state.data.record.serviceStatus,
            jobTitle: this.state.data.record.jobTitle,
            administrativeUnit: this.state.data.record.administrativeUnit,
            numberCCertificate: this.state.data.record.numberCCertificate,
            address: this.state.data.record.address,
            mobile: this.state.data.record.mobile,
            dateEmployeement: this.state.data.record.dateEmployeement,
            gender: this.state.data.record.gender,
            residenceCode: this.state.data.record.residenceCode,
            isActive: this.state.data.record.isActive,
            personCode: this.state.data.record.personCode,
            cartNumber: this.state.data.record.cartNumber,
            shNumber: this.state.data.record.shNumber,
            bankId: this.state.data.record.bankId,
            insuranceId: this.state.data.record.insuranceId,
            insuranceName: this.state.data.record.insuranecName,
            isInsurance: this.state.data.record.isInsurance,
            isTax: this.state.data.record.isTax,


        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/persennels/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    loadPersonsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getstate/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    loadLookupCerOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getlookupceritifacte/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    loadLookupFieldStudy(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getlookupfieldstudy/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    changeInsurance(val) {
        this.state.data.record.isInsurance = val;
        this.setState({ data: this.state.data });
    }
    loadLookupJobs(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getlookupjob/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    loadLookupUnit(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getlookupunit/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };


    loadLookupBank(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getlookupbank/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    insuranceLookup(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getinsurance/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };


    setPersonType(v, e) {
        this.state.data.record.maritalStatus = v;
        this.setState({ data: this.state.data });
    }
    setGenderType(v, e) {
        this.state.data.record.gender = v;
        this.setState({ data: this.state.data });
    }
    setService(v, e) {
        this.state.data.record.serviceStatus = v;
        this.setState({ data: this.state.data });
    }


    setBirthDay(v) {
        let data = v.toString();
        this.state.data.record.birthDay = data;
        this.setState({ data: this.state.data });
    }
    setDateEmployeement(v) {
        let data = v.toString();
        this.state.data.record.dateEmployeement = data;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <NavLink className="back-to" to="/persennels/"><em className="icon ni ni-arrow-left"></em><span>فهرست پرسنلی</span></NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">اطلاعات پرسنل</h5>
                                        </div>
                                        <div className="card-body">
                                            <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                <div className="row">
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره پرسنلی</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" type="text" defaultValue={this.state.data.record.personCode} onChange={e => this.state.data.record.personCode = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row g-3">
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isInsurance} onChange={e => this.changeInsurance(e.target.checked)} id="customSwitch2" />
                                                                <label className="custom-control-label" htmlFor="customSwitch2">عدم ارسال لیست بیمه </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">

                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isTax} onChange={e => this.state.data.record.isTax = e.target.checked} id="customSwitch3" />
                                                                <label className="custom-control-label" htmlFor="customSwitch3">عدم ارسال لیست مالیات </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row g-3">
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">نام</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" type="text" defaultValue={this.state.data.record.firstName} onChange={e => this.state.data.record.firstName = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">نام خانوادگی</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" type="text" defaultValue={this.state.data.record.lastName} onChange={e => this.state.data.record.lastName = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">نام پدر</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" type="text" defaultValue={this.state.data.record.fatherName} onChange={e => this.state.data.record.fatherName = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">کد ملی</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="11" type="text" defaultValue={this.state.data.record.nationalCode} onChange={e => this.state.data.record.nationalCode = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره شناسنامه</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="11" type="text" defaultValue={this.state.data.record.numberId} onChange={e => this.state.data.record.numberId = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره مسلسل شناسنامه</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" maxLength="20" type="text" defaultValue={this.state.data.record.numberCCertificate} onChange={e => this.state.data.record.numberCCertificate = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ تولد</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.birthDay}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "34px",
                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setBirthDay(e)}
                                                                    mobileLabels={{
                                                                        OK: "انتخاب",
                                                                        CANCEL: "بستن",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">محل صدور</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.placeOfIssue > 0 ? [{ value: this.state.data.record.placeOfIssue, label: this.state.data.record.placeOfIssueStr }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب محل صدور"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadPersonsOptions}
                                                                    onChange={e => this.state.data.record.placeOfIssue = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">وضعیت تاهل</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" type="text" defaultValue={this.state.data.record.maritalStatus} onChange={e => this.setPersonType(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب وضعیت</option>
                                                                    <option value="1">مجرد</option>
                                                                    <option value="2">متاهل</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">تعداد فرزندان</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="20" type="text" defaultValue={this.state.data.record.numberOfChildren} onChange={e => this.state.data.record.numberOfChildren = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                   
                                                    {this.state.data.record.isInsurance === false &&
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">شماره بیمه</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control ltr" maxLength="20" type="text" defaultValue={this.state.data.record.insuranceNumber} onChange={e => this.state.data.record.insuranceNumber = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.data.record.isInsurance === false &&
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">نوع بیمه</label>
                                                                <div className="form-control-wrap">
                                                                    <SelectAsync
                                                                        defaultValue={this.state.data.record.insuranceId > 0 ? [{ value: this.state.data.record.insuranceId, label: this.state.data.record.insuranceIdStr }] : null}
                                                                        isMulti={false}
                                                                        placeholder="انتخاب نوع بیمه"
                                                                        defaultOptions
                                                                        isSearchable
                                                                        loadOptions={this.insuranceLookup}
                                                                        onChange={e => this.state.data.record.insuranceId = e.value}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.data.record.isInsurance === false &&
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">نام بیمه</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control ltr" maxLength="20" type="text" defaultValue={this.state.data.record.insuranceName} onChange={e => this.state.data.record.insuranceName = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                  
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره موبایل</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="11" type="text" defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">کد محل سکونت</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="5" type="text" defaultValue={this.state.data.record.residenceCode} onChange={e => this.state.data.record.residenceCode = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">جنسیت</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" type="text" defaultValue={this.state.data.record.gender} onChange={e => this.setGenderType(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب جنسیت</option>
                                                                    <option value="1">مرد</option>
                                                                    <option value="2">زن</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره کارت</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="16" type="text" defaultValue={this.state.data.record.cartNumber} onChange={e => this.state.data.record.cartNumber = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره شبا</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control ltr" maxLength="24" type="text" defaultValue={this.state.data.record.shNumber} onChange={e => this.state.data.record.shNumber = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">بانک</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.bankId > 0 ? [{ value: this.state.data.record.bankId, label: this.state.data.record.bankIdStr }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب محل صدور"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupBank}
                                                                    onChange={e => this.state.data.record.bankId = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">آخرین مدرک تحصیلی</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.lastCertificate > 0 ? [{ value: this.state.data.record.lastCertificate, label: this.state.data.record.lastCertificateStr }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب محل صدور"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupCerOptions}
                                                                    onChange={e => this.state.data.record.lastCertificate = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">رشته تحصیلی</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.fieldStudy > 0 ? [{ value: this.state.data.record.fieldStudy, label: this.state.data.record.fieldStudyStr }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب رشته تحصیلی"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupFieldStudy}
                                                                    onChange={e => this.state.data.record.fieldStudy = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">وضعیت خدمت سربازی</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" type="text" defaultValue={this.state.data.record.serviceStatus} onChange={e => this.setService(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب وضعیت خدمت</option>
                                                                    <option value="1">پایان خدمت</option>
                                                                    <option value="2">معاف</option>
                                                                    <option value="3">بدون کارت پایان خدمت</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">عنوان شغلی</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.jobTitle > 0 ? [{ value: this.state.data.record.jobTitle, label: this.state.data.record.jobTitleStr }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب عنوان شغلی"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupJobs}
                                                                    onChange={e => this.state.data.record.jobTitle = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">واحد اداری</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.administrativeUnit > 0 ? [{ value: this.state.data.record.administrativeUnit, label: this.state.data.record.administrativeUnitStr }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب واحد اداری"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupUnit}
                                                                    onChange={e => this.state.data.record.administrativeUnit = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ استخدام</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"

                                                                    value={this.state.data.record.dateEmployeement}
                                                                    style={{
                                                                        height: "34px",
                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setDateEmployeement(e)}
                                                                    mobileLabels={{
                                                                        OK: "انتخاب",
                                                                        CANCEL: "بستن",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <label className="form-label">آدرس</label>
                                                        <div className="form-control-wrap">
                                                            <textarea className="form-control" type="text" defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-switch">
                                                            <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isActive} onChange={e => this.state.data.record.isActive = e.target.checked} id="customSwitch5" />
                                                            <label className="custom-control-label" htmlFor="customSwitch5"> کارمند فعال </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <button type="submit" className="btn btn-lg btn-primary">ثبت پرسنل</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}